import styled from "styled-components";

import { highlights, primary } from "@formant/ui/component/common/Colors";

export const DucalisButton = styled.button`
    all: unset;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    color: ${primary.silver};
    border-radius: 1.875rem;
    padding: 0.125rem 0.625rem;
    transition: 200ms ease-in-out;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.0375rem;
    height: 1.5rem;
    gap: 6px;
    &:hover {
        background-color: ${primary.steel02};
        color: white !important;
    }
    & span {
        all: unset !important;
        position: relative !important;
        color: black !important;
        background-color: ${highlights.blue} !important;
        border: 0.125rem solid ${primary.steel01};
        height: 1.125rem !important;
        width: auto !important;
        border-radius: 1.5rem !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 0.8125rem !important;
        padding-left: 0.375rem !important;
        padding-right: 0.375rem !important;
        letter-spacing: 0.6px !important;
        &:hover {
            border: 0.125rem solid ${primary.steel01};
        }
    }
`;

export const DucalisChangeLog = styled.div`
    font-size: 0.8125rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    &:hover {
        color: white;
    }
`;
